/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AgendaInputs */



/**
* | output |
* | --- |
* | "Agenda" |
*
* @param {Nav_AgendaInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_agenda = /** @type {((inputs?: Nav_AgendaInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AgendaInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Agenda")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agenda")
	return /** @type {LocalizedString} */ ("Agenda")
});